/*
  Boitoi glass header (Oct 2026)
  - Main menu: a soft pill and a Boitoi-gradient underline slide to the item under the pointer or keyboard
    focus, then settle back on the section you are in.
  - Search: Ctrl K / Cmd K or "/" opens the search pop-up; a small key hint shows inside the search box.
  - Cart badge gives a little pop when the count changes.
*/
(function () {
  if (window.__bxGlass) return;
  window.__bxGlass = true;

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function pathOf(href) {
    if (!href || href.charAt(0) === '#') return '';
    try {
      var u = new URL(href, location.href);
      if (u.host !== location.host) return '';
      return u.pathname.replace(/\/+$/, '') || '/';
    } catch (e) {
      return '';
    }
  }

  function initMenu() {
    var bar = document.querySelector('.m-header__desktop .m-menu-bar');
    var menu = bar && bar.querySelector('.m-menu');
    if (!menu || bar.__bxg) return;
    var items = Array.prototype.filter.call(menu.children, function (li) {
      return li.classList && li.classList.contains('m-menu__item') && li.querySelector('.m-menu__link--main');
    });
    if (!items.length) return;
    bar.__bxg = true;

    var pill = document.createElement('span');
    var line = document.createElement('span');
    pill.className = 'bxg-pill';
    line.className = 'bxg-line';
    pill.setAttribute('aria-hidden', 'true');
    line.setAttribute('aria-hidden', 'true');
    bar.appendChild(pill);
    bar.appendChild(line);
    bar.classList.add('bxg-ready');

    function linkOf(li) {
      return li ? li.querySelector('.m-menu__link--main') : null;
    }

    /* the section you are in: main link prefix, or an exact match inside its dropdown */
    var here = pathOf(location.href);
    var active = null;
    var best = 0;
    items.forEach(function (li) {
      var p = pathOf(linkOf(li).getAttribute('href'));
      if (p && p !== '/' && (here === p || here.indexOf(p + '/') === 0) && p.length > best) {
        best = p.length;
        active = li;
      }
    });
    if (!active) {
      items.some(function (li) {
        var subs = li.querySelectorAll('.m-mega-menu a[href]');
        for (var i = 0; i < subs.length; i++) {
          var sp = pathOf(subs[i].getAttribute('href'));
          if (sp && sp !== '/' && sp === here) {
            active = li;
            return true;
          }
        }
        return false;
      });
    }
    if (active) {
      active.classList.add('bxg-active');
      if (pathOf(linkOf(active).getAttribute('href')) === here) linkOf(active).setAttribute('aria-current', 'page');
    }

    function place(el, a) {
      var hb = bar.getBoundingClientRect();
      var r = a.getBoundingClientRect();
      if (!r.width) return;
      var cs = getComputedStyle(menu);
      var px = parseFloat(cs.getPropertyValue('--main-link-px')) || 0;
      var py = parseFloat(cs.getPropertyValue('--main-link-py')) || 0;
      var x = r.left - hb.left;
      var y = r.top - hb.top;
      if (el === pill) {
        var inset = Math.max(4, Math.min(8, py - 3));
        el.style.width = r.width + 'px';
        el.style.height = r.height - inset * 2 + 'px';
        el.style.transform = 'translate3d(' + x + 'px,' + (y + inset) + 'px,0)';
      } else {
        el.style.width = Math.max(12, r.width - px * 2) + 'px';
        el.style.transform = 'translate3d(' + (x + px) + 'px,' + (y + r.height - py + 3) + 'px,0)';
      }
    }

    /* mode: 'slide' (animate from where it is), 'jump' (appear in place, fade only), 'snap' (no animation) */
    function show(el, li, mode) {
      var a = linkOf(li);
      if (!a) return;
      if (mode !== 'slide' || reduce.matches) {
        el.classList.add(mode === 'snap' ? 'bxg-snap' : 'bxg-jump');
      }
      place(el, a);
      el.classList.add('is-on');
      void el.offsetWidth;
      el.classList.remove('bxg-snap', 'bxg-jump');
    }

    var current = null;

    function enter(li) {
      if (current === li) return;
      current = li;
      show(pill, li, pill.classList.contains('is-on') ? 'slide' : 'jump');
      show(line, li, line.classList.contains('is-on') ? 'slide' : 'jump');
    }

    function leave() {
      current = null;
      pill.classList.remove('is-on');
      if (active) show(line, active, 'slide');
      else line.classList.remove('is-on');
    }

    items.forEach(function (li) {
      li.addEventListener('mouseenter', function () { enter(li); });
      li.addEventListener('focusin', function () { enter(li); });
    });
    menu.addEventListener('mouseleave', leave);
    menu.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !menu.contains(e.relatedTarget)) {
        if (!menu.matches(':hover')) leave();
      }
    });

    function settle() {
      if (current) {
        show(pill, current, 'snap');
        show(line, current, 'snap');
      } else if (active) {
        show(line, active, 'snap');
      }
    }
    settle();

    var raf = 0;
    function remeasure() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(settle);
    }
    if (window.ResizeObserver) new ResizeObserver(remeasure).observe(bar);
    else window.addEventListener('resize', remeasure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    window.addEventListener('load', remeasure);
  }

  function initSearchHint() {
    var box = document.querySelector('.m-header__desktop .m-search-form--full');
    if (!box || box.querySelector('.bxg-kbd')) return;
    var mac = /Mac|iPhone|iPad/i.test(navigator.platform || navigator.userAgent || '');
    var k = document.createElement('kbd');
    k.className = 'bxg-kbd';
    k.setAttribute('aria-hidden', 'true');
    k.textContent = mac ? '⌘ K' : 'Ctrl K';
    var btn = box.querySelector('.m-search-form__button');
    if (btn && btn.parentNode === box) box.insertBefore(k, btn);
    else box.appendChild(k);
  }

  function visible(el) {
    return !!(el && el.getClientRects().length);
  }

  document.addEventListener('keydown', function (e) {
    if (e.defaultPrevented || e.altKey) return;
    var t = e.target;
    var typing = t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName || ''));
    var isK = (e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey) && !e.shiftKey;
    var isSlash = e.key === '/' && !typing && !e.metaKey && !e.ctrlKey;
    if (!isK && !isSlash) return;
    if (t && t.closest && t.closest('[data-search-popup]')) return;
    var triggers = document.querySelectorAll('m-header [data-open-search-popup]');
    for (var i = 0; i < triggers.length; i++) {
      if (visible(triggers[i])) {
        e.preventDefault();
        triggers[i].click();
        return;
      }
    }
  });

  function initBadges() {
    var badges = document.querySelectorAll('m-header .m-cart-count');
    Array.prototype.forEach.call(badges, function (b) {
      if (b.__bxg || !window.MutationObserver) return;
      b.__bxg = true;
      var last = (b.textContent || '').trim();
      new MutationObserver(function () {
        var now = (b.textContent || '').trim();
        if (now === last) return;
        last = now;
        if (reduce.matches) return;
        b.classList.remove('bxg-pop');
        void b.offsetWidth;
        b.classList.add('bxg-pop');
      }).observe(b, { childList: true, characterData: true, subtree: true });
    });
  }

  function init() {
    initMenu();
    initSearchHint();
    initBadges();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 0);
  });
})();